module.exports = __webpack_public_path__ + "static/media/20.bf8ea551.jpeg";